import { Component, Input, OnInit, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MaterialsService } from 'src/app/providers/services/materials.service';
import { SkidsService } from 'src/app/providers/services/skids.service';
import { Mission } from 'src/app/storage/models/mission.model';
import { SkidMission } from 'src/app/storage/models/skid-mission.model';
import { Skid } from 'src/app/storage/models/skid.model';

@Component({
    selector: 'app-add-skid',
    templateUrl: './add-skid.component.html',
    styleUrls: ['./add-skid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddSkidComponent implements OnInit, OnDestroy {
  displayedSkids: Skid[];
  skids: Skid[];

  @Input() mission: Mission;
  @Input() missionSkid: SkidMission;
  @Output() closeModal = new EventEmitter<any>();

  private skidsSubscription: Subscription;

  constructor(
    private skidsService: SkidsService,
    private materialsService: MaterialsService
  ) { }

  ngOnInit(): void {
    this.skidsSubscription = this.skidsService.skids$.subscribe((skids: Skid[]) => {
      const missionSkids = this.skidsService.missionSkids$.getValue();

      this.skids = skids
        // Order skids by attributes
        .sort((a, b) => {
        return a.pumpMaxFlowrate === b.pumpMaxFlowrate ?
                ( a.pumpMaxPressure > b.pumpMaxPressure ? 1 : -1) :
                ( a.pumpMaxFlowrate > b.pumpMaxFlowrate ? 1 : -1 );
        })
        // Remove selected skid
        .filter(skid => missionSkids.find(missionSkid => skid.skidId === missionSkid.skidId) === undefined);

      this.materialsService.setSkidsEquipments(this.skids);
      this.displayedSkids = this.skids;
    });
  }

  ngOnDestroy(): void {
    if (this.skidsSubscription) { this.skidsSubscription.unsubscribe(); }
  }

  close(): void {
    this.closeModal.emit();
  }

  addSkid(skid: Skid): void {
    this.closeModal.emit(skid);
  }

  filterSkids($event): void {
    const value = $event.target.value;

    this.displayedSkids = this.skids.filter(skid => {
      // List attribute to filter on
      const attributesToFilterOn = [
        skid.skidName
      ];

      // Find at least one attribute that checks the criterion
      return attributesToFilterOn.find(attribute =>
        attribute.toUpperCase().includes(value.toUpperCase())
      ) != null;
    });
  }

  isNoDigital(skid: Skid): boolean {
    return !(skid.hasPump) && !(skid.hasGateway) && !(skid.hasFlowmeter);
  }

}
